import api from '../api'

export default {
    namespaced: true,
    state: {
        allUnionList: [],
        unionList: [],
        unionListTotal: 0,
        unionDetail: {
            info: null,
            clubList: [],
            total: 0
        },
        mainTribeList: {//主联盟列表
            beanList: [],
            total: 0
        }
    },
    mutations: {
        setStateAllUnionList(state, info) {
            state.allUnionList = info;
        },
        setStateMainTribeList(state, info) {
            state.mainTribeList = info;
        },
        setStateUnionList(state, info) {
            state.unionList = info.beanList;
            state.unionListTotal = info.total;
        },
        setStateUnionDetail(state, info) {
            state.unionDetail = Object.assign({}, state.unionDetail, {
                info: info.infoBean,
                clubList: info.list.beanList,
                total: info.list.total,
            });
        },
        setStateUnionDetail_info(state, info) {
            if (info === 'delete') {
                state.unionDetail.info = null;
            } else {
                state.unionDetail.info = Object.assign({}, state.unionDetail.info, info);
            }
        },
    },
    actions: {
        getAllUnionList({commit}) {
            return api.get('/tribe/all', '所有联盟列表').then(res => {
                commit('setStateAllUnionList', res.data)
            })
        },
        getUnionList({commit}, params) {
            return api.post('/tribe/search', '联盟列表', params).then(res => {
                commit('setStateUnionList', res.data)
            })
        },
        getUnionDetail({commit}, {unionId, ...params}) {
            return api.post(`/tribe/tribeInfo/${unionId}`, '联盟详情', params).then(res => {
                commit('setStateUnionDetail', res.data)
            })
        },
        getTribeProfitAPI(store, params) {
            return api.post('/tribe/getTribeProfit/', '联盟分成', params)
        },
        updateUnionConfig(store, {unionId, ...params}) {
            return api.post(`/tribe/updateTribeInfo/${unionId}`, '联盟修改', params)
        },
        updateRebateConfig(store, {tribeId, ...params}) {
            return api.post(`/tribe/updateRebateConfig/${tribeId}`, '修改俱乐部对赌信息', params)
        },
        updateUnionRanDomId(store, params) {
            return api.post(`/tribe/updateTribeRandomId`, '修改联盟显性id', params)
        },
        deleteClub(store, {unionId, ...params}) {
            return api.post(`/tribe/delClub/${unionId}`, '联盟踢出俱乐部', params)
        },
        getMainTribeList({commit}) {
            return api.post('/tribe/mainTribe/list', '主联盟列表', {
                page: 1,
                size: 1000000
            }).then(res => {
                commit('setStateMainTribeList', res.data)
            })
        },
        updateIsMainStatus(store, params) {
            return api.post(`/tribe/setMainTribe`, '联盟设置主联盟开关', params)
        },
        updateMainTribe(store,params){
            return api.post(`/tribe/changeMainTribe`, '设置主联盟', params)
        }
    }
}